import data from './data'

import computed from './computed'
import methods from './methods'
import mounted from './mounted'

export default {
  data,
  computed,
  methods,
  mounted,
  /* route API for Professional rules */
  resourcePath: '/v1/professional/agendas/rules'
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/rules/resources/index.js